import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import Layout from '../../wrappers/layout';
import IndicatorCard from './components/indicator-card';
import BuySellMetals from './components/buy-sell-metals';
import DashboardBanner from './components/dashboard-banner';
import PageHeader from '../../shared/page-header';
import { dashboardStore } from '../../store/DashboardStore';
import { userStore } from '../../store/UserStore';
import DashboardService from '../../services/dashboard.service';
import RealisedService from '../../services/realised.service';
import Loader from '../../shared/common/loader';
import Banner from '../../assets/images/banner.jpg';
import { formatAmount } from '../../utils';
import NomineeModal from 'pages/profile/components/NomineeModal';
import Pushnotification from '../login/services/login.service';
import { getMessaging, getToken } from 'firebase/messaging';
import { app, db, auth } from '../../firebaseConfig';
import RedeemGiftModal from 'pages/gift-module/RedeemGiftModal';
import { useHistory } from 'react-router-dom';
import SupportButton from 'shared/common/supportButton/SupportButton';
// import SupportButton from 'shared/common/supportButton/SupportButton';
import downArrow from 'assets/icons/chevron-down.svg';
import upArrow from 'assets/icons/chevron-up.svg';
import { toast } from 'react-toastify';
import './index.css';
import Analytics from 'pages/analytics';
const metalsWithCode = [
  { code: 'Au', name: 'Gold' },
  { code: 'Ag', name: 'Silver' },
  { code: 'Pt', name: 'Platinum' },
  { code: 'Pd', name: 'Palladium' },
];

interface PropsType {}

const DashboardPage: React.FC<PropsType> = () => {
  const renderCheck = useRef(false);
  // eslint-disable-next-line
  const [
    customerHolding,
    wallet,
    summary,
    accountsHolding,
    metals,
    setCustomerHolding,
    setAccountHolding,
    setWallet,
    setSummary,
    setMetals,
  ] = dashboardStore((state: any) => [
    state.customerHolding,
    state.wallet,
    state.summary,
    state.accountsHolding,
    state.metals,
    state.setCustomerHolding,
    state.setAccountHolding,
    state.setWallet,
    state.setSummary,
    state.setMetals,
  ]);
  const [customerId, user, selectedAccount, customer] = userStore(
    (state: any) => [
      state.customerId,
      state.user,
      state.selectedAccount,
      state.customer,
    ]
  );

  // const metalObj = ['Ag', 'Pd', 'Pt', 'Au'];
  const [loading, setLoading] = useState<boolean>(false);
  const [holdings, setHoldings] = useState([]);
  const [open, setOpen] = useState<any>(false);
  const [customerInvestedValue, setCustomerInvestedValue] = useState(0);

  let arrayOfObjects;
  const history = useHistory();
  const searchParams = new URLSearchParams(window.location.search);
  const gift = searchParams.get('gift');

  const ecom = searchParams.get('ecom');
  const decodedecom = JSON.parse(decodeURIComponent(ecom));
  // const decodedMetal = gift ? decodeURIComponent(gift) : ((decodedecom ? decodedecom.metalType) : undefined);
  const decodedMetal = gift
    ? decodeURIComponent(gift)
    : decodedecom
    ? decodedecom.metalType
    : undefined;
  useEffect(() => {
    if (selectedAccount) {
      let acHoldings = accountsHolding.find(
        (acc) => acc.accountId === selectedAccount.accountId
      );
      if (acHoldings) setHoldings(acHoldings.accountHolding);
    }
  }, [accountsHolding, selectedAccount]);

  useEffect((): any => {
    getPassbookSummary();
    getAllMetals();
    getCustomerHoldings();
    storeFCMToken();
    document.title = 'Dashboard - CoinBazaar Digital';
  }, []);

  useEffect(() => {
    if (renderCheck.current) {
      getPassbookSummary();
      getAllMetals();
    } else {
      renderCheck.current = true;
    }
  }, [customerId]);

  /**
   * Get passbook summary details
   */
  const getPassbookSummary = async () => {
    setLoading(true);
    try {
      const res: any = await DashboardService.getPassbookSummary(
        customerId,
        user?.userId
      );
      if (res.status === 200 && res.data.data) {
        setCustomerHolding(
          res.data.data.metal.customerHolding.sort((a: any, b: any) =>
            a.metal.localeCompare(b.metal)
          )
        );
        setAccountHolding(res.data.data.metal.accountsHolding);
        setWallet(res.data.data.wallet);
        setSummary(res.data.data.summary);

        setLoading(false);
      }
    } catch (e: any) {
      setLoading(false);
    }
  };

  /**
   * Get all metals
   */
  const getAllMetals = async () => {
    setLoading(true);
    try {
      const res: any = await DashboardService.getAllMetals();
      if (res.status === 200 && res.data.data.result.length > 0) {
        setMetals(res.data.data.result);
        setLoading(false);
      }
    } catch (e: any) {
      setLoading(false);
    }
  };

  const getCustomerHoldings = async() =>{
    setLoading(true);
    try {
      const payload = {
        customerId: customerId,
        partnerId: customer?.partner?.id,
      }
      const res = await DashboardService.getInvestmentValue(payload);
      setCustomerInvestedValue(res?.data?.data?.totalInvestmentAmount);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Something went worng!");
    }
  }

  const storeFCMToken = async () => {
    try {
      const messaging = getMessaging(app);
      const userId = user?.customers[0]?.user?.userId;

      // Retrieve the FCM token
      getToken(messaging)
        .then(async (token) => {
          const data = { webtoken: token, user_id: userId };
          const storeToken = await Pushnotification.storeFcmToken(data);
          // console.log('FCM Token:', token);
        })
        .catch((error) => {
          console.error('Error getting FCM token:', error);
        });
    } catch (err) {
      console.log(err);
    }
  };

  const claimGift = () => {
    history.push('/gift?giftListReceived=true');
  };
  const onCancel = () => {
    localStorage.setItem('popupGiftShown', 'true');

    setOpen(false);
  };

  const mapMetalDetails = (apiResponse, metalsWithCode) => {
    // Create a lookup object from the API response
    const apiResponseLookup = {};
    apiResponse.forEach((metal) => {
      apiResponseLookup[metal.metal] = metal;
    });

    // Map the details from the API response to metalsWithCode
    metalsWithCode.forEach((metal) => {
      const metalDetails = apiResponseLookup[metal.code];
      if (metalDetails) {
        metal.quantity = metalDetails.quantity;
        metal.lockQuantity = metalDetails.lockQuantity;
        metal.value = metalDetails.value;
        metal.lockValue = metalDetails.lockValue;
        metal.unitPrice = metalDetails.unitPrice;
      }
    });

    return metalsWithCode;
  };

  const updatedMetalsWithCode = mapMetalDetails(holdings, metalsWithCode);

  // realised data

  useEffect(() => {
    const hasPopupBeenShown = localStorage.getItem('popupGiftShown');
    if (
      !hasPopupBeenShown &&
      customer?.giftCount > 0 &&
      customer?.customerCategory === 'UNREGISTERED'
    ) {
      setOpen(true);
      localStorage.setItem('popupGiftShown', 'true');
    }
  }, []);

  // console.log('arrayOfObjects', realisedData);

  useEffect(() => {
    const sipLSdata = localStorage.getItem('sipdata');
    if (sipLSdata !== null) {
      history.push({
        pathname: '/sip',
        state: { sipdata: JSON.parse(sipLSdata) },
      });
    }

    const manualSipLSdata = localStorage.getItem('manualSipData');
    if (manualSipLSdata !== null) {
      const manualSipObj = JSON.parse(manualSipLSdata);
      const manualSipEncObj = encodeURIComponent(manualSipLSdata);

      let redirectUrl = `/sip-payment-schedule/${manualSipObj?.sipId}?data=${manualSipEncObj}`;
     
      history.push(redirectUrl);
    }
  }, []);
  return (
    <Layout>
      {loading ? (
        <Loader />
      ) : (
        <div>
          {/*<Toast/>*/}
          <PageHeader
            mainTitle={user.displayName}
            subTitle='Below are your total holdings'
          />

          <Row>
            <Col md={8}>
              <Row>
                <Col md={6}>
                  <div className='my-1 col col-sm-12 '>
                    <IndicatorCard
                      isMain
                      heading={
                        <span className='metal-heading'>
                          Your Invested Value
                          <span className='metal-note'>
                            *(Exclusive of GST)
                          </span>
                        </span>
                      }
                      amount={`₹ ${formatAmount(customerInvestedValue) || '0.00'}`}
                      backgroundColor='#3A3733'
                      addClassName='py-2 tot-card'
                      styles=''
                    />
                  </div>
                </Col>
                <Col md={6}>
                  <div className='my-1 col col-sm-12 '>
                    <IndicatorCard
                      isMain
                      heading='In Wallet'
                      amount={`₹ ${formatAmount(wallet.balance)}` || '0.00'}
                      styles=''
                      addClassName='wallet '
                      earmarkedBalance={`₹ ${formatAmount(wallet.lockBalance)}`}
                      redirectLink={`/wallet`}
                    />
                  </div>
                </Col>
              </Row>
              {/*<div>*/}
              {/*<div className="my-1 col col-sm-12 col-md-4">*/}
              {/*  <IndicatorCard*/}
              {/*      isMain*/}
              {/*      heading="Total Holdings"*/}
              {/*      amount={`₹ ${formatAmount(summary.walletBalance + summary.metalBalance) || '0.00'}`}*/}
              {/*      backgroundColor="#301250"*/}
              {/*      addClassName="h-100 tot-card"*/}
              {/*      styles=""*/}
              {/*  />*/}
              {/*</div>*/}
              {/*<div className="my-1 col col-sm-12 col-md-4">*/}
              {/*  <IndicatorCard*/}
              {/*      isMain*/}
              {/*      heading="In Wallet"*/}
              {/*      amount={`₹ ${formatAmount(wallet.balance)}` || '0.00'}*/}
              {/*      styles=""*/}
              {/*      addClassName="wallet "*/}
              {/*      earmarkedBalance={`₹ ${formatAmount(wallet.lockBalance)}`}*/}
              {/*  />*/}
              {/*</div>*/}
              {/*</div>*/}
              <div className='col-md-8 overflow-auto d-sm-block d-md-none'>
                <div className='d-flex flex-column bd-highlight'>
                  {customerHolding && customerHolding.length === 0 ? (
                    <>
                      {[1, 2, 3, 4].map((item: any, index: number) => (
                        <div className='mb-2 flex-fill flex-shrink-0'>
                          <div key={index}>
                            <IndicatorCard
                              // eslint-disable-next-line react/no-array-index-key
                              isMain={false}
                              heading={null}
                              amount={null}
                              quantity={null}
                              addClassName={` metal`}
                              earmarkedBalance={null}
                            />
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      {updatedMetalsWithCode?.map(
                        (account: any, index: number) => (
                          <div className='mb-2 flex-fill flex-shrink-0'>
                            <div key={index} className=''>
                              <IndicatorCard
                                // eslint-disable-next-line react/no-array-index-key
                                isMain={false}
                                heading={account.name ? account.name : ''}
                                amount={`₹ ${
                                  formatAmount(account.value) || ' 0.00'
                                }`}
                                quantity={`${account.quantity?.toFixed(4)}`}
                                addClassName={`${account.metal} metal mobileCard`}
                                earmarkedBalance={account.lockQuantity || ''}
                              />
                            </div>
                          </div>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>
              <div className='d-md-grid grid d-sm-flex mt-2 d-none d-sm-block'>
                {customerHolding && customerHolding.length === 0 ? (
                  <>
                    {[1, 2, 3, 4].map((item: any, index: number) => (
                      <div key={index}>
                        <IndicatorCard
                          // eslint-disable-next-line react/no-array-index-key
                          isMain={false}
                          heading={null}
                          amount={null}
                          quantity={null}
                          addClassName={` metal`}
                          earmarkedBalance={null}
                        />
                      </div>
                    ))}
                  </>
                ) : (
                  <>
                    {updatedMetalsWithCode?.map(
                      (account: any, index: number) => (
                        <div key={index}>
                          <IndicatorCard
                            // eslint-disable-next-line react/no-array-index-key
                            isMain={false}
                            heading={account.name ? account.name : ''}
                            metalCode={account.code}
                            redirectLink={`/passbook?metalCode=${account.code}`}
                            amount={`₹ ${
                              formatAmount(account.value) || ' 0.00'
                            }`}
                            quantity={`${account.quantity?.toFixed(4)}`}
                            addClassName={`${account.code} metal`}
                            earmarkedBalance={account.lockQuantity || ''}
                          />
                        </div>
                      )
                    )}
                  </>
                )}
              </div>
              <DashboardBanner image={Banner} />
            </Col>
            <Col md={4}>
              <BuySellMetals
                metals={metals}
                walletBalance={summary.walletBalance}
                isDashboard={true}
                getPassbookSummary={getPassbookSummary}
                giftMetal={decodedMetal}
              />
            </Col>
          </Row>
        </div>
      )}
      {/* {customer.customerCategory === 'UNREGISTERED' &&
        customer?.nomineeDetails?.length < 1 && <NomineeModal />} */}
      {customer.giftCount > 0 && customer?.customerCategory === 'UNREGISTERED' && (
        <RedeemGiftModal
          showModal={open}
          closeModal={setOpen}
          proceed={claimGift}
          cancel={onCancel}
          text={`
      
            You have received a gift🎁
            To claim it, please go to Gift Page.
            Thank you!
         
        `}
          keytext={'gift'}
          okButton={'Go to Gift'}
          cancelButton={'Later'}
          title={'Your Gift Awaits!'}
        />
      )}
    </Layout>
  );
};

export default DashboardPage;

